export default "__VITE_PUBLIC_ASSET__0a8b012e__"